import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import Tooltip from "@mui/material/Tooltip";
import { useAuth } from "../../Auth";
import ReactGA from "react-ga4";
import axios from "axios";

// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/grid";
import "swiper/css/pagination";

// import required modules
import { Grid, Pagination } from "swiper";

import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const LearningElement = styled.section`
  display: flex;
  justify-content: center;
  padding: 57px 20px 52px 20px;
  background: rgba(48, 52, 64, 1);

  .cmp-learning-container {
    max-width: 1154px;
    width: 100%;
  }

  .cmp-learning-header {
    display: flex;
    align-items: center;
    margin-bottom: 35px;

    @media (max-width: 730px) {
      flex-direction: column;
    }

    .cmp-learning-header-content {
      h2 {
        font-size: 24px;
        font-weight: 700;
        line-height: 28px;
        letter-spacing: -0.48px;
        color: #fff;
        margin-right: 40px;

        @media (max-width: 730px) {
          margin-right: unset;
          margin-bottom: 20px;
        }
      }
    }

    ul.cmp-learning-tabs {
      display: flex;

      @media (max-width: 730px) {
        order: 3;
      }

      li {
        &:not(:last-child) {
          margin-right: 53px;
        }

        button {
          background: none;
          border: none;
          font-size: 18px;
          font-weight: 700;
          line-height: 21px;
          letter-spacing: -0.36px;
          color: #c4c5c8;
          padding: 0;

          span {
            color: #dc6126;
          }

          &:hover {
            color: #fff;
            cursor: pointer;
          }

          &.active {
            color: #fff;
            position: relative;

            &::after {
              content: " ";
              position: absolute;
              height: 3px;
              left: 0;
              right: 0;
              bottom: -10px;
              background: #dc6126;
            }
          }
        }
      }
    }

    a {
      @media (max-width: 730px) {
        order: 2;
        margin-left: unset;
        margin-bottom: 40px;
      }

      margin-left: auto;
      border-radius: 30px;
      background: #dc6126;
      border: 2px solid #dc6126;
      text-decoration: none;
      color: #fff;
      font-size: 14px;
      font-weight: 500;
      line-height: 22px;
      letter-spacing: 0;
      padding: 4px 24px;
    }
  }

  .cmp-learning-card {
    background-size: cover;
    background-repeat: no-repeat;
    max-width: 365px;
    width: 100%;
    height: 240px;
    padding: 26px 24px 21px 24px;
    display: flex;
    flex-direction: column;
    box-shadow: 0px 3px 6px #00000029;
    border-radius: 7px;
    background: #fff;
    box-sizing: border-box;

    .cmp-learning-card-header {
      display: flex;
      flex-direction: column;
      align-items: flex-start;

      .cmp-learning-card-title {
        font-size: 18px;
        line-height: 22px;
        font-weight: 500;
        color: #000;
        max-width: 264px;
      }

      .cmp-learning-card-link {
        border-radius: 30px;
        background: #fff;
        border: 2px solid #dc6126;
        text-decoration: none;
        color: #242731;
        font-size: 14px;
        line-height: 22px;
        letter-spacing: 0;
        padding: 6px 26px;
        font-weight: 700;
        margin-top: 15px;
      }
    }

    .cmp-learning-card-footer {
      margin-top: auto;
      display: flex;
      justify-content: space-between;

      .cmp-learning-card-due-date {
        font-size: 14px;
        line-height: 16px;
      }

      .cmp-learning-card-course-length {
        font-size: 16px;
        line-height: 19px;
        letter-spacing: -0.48px;
        color: #000000;
        font-weight: 700;
        margin-left: auto;
      }
    }
  }

  .cmp-learning-assignments {
    .swiper-wrapper {
      height: 830px;

      @media (min-width: 769px) {
        height: 562px;
      }

      @media (max-width: 768px) {
        height: 560px;
      }
    }

    .swiper-slide {
      height: unset;
    }

    .swiper-pagination {
      bottom: 0px;

      .swiper-pagination-bullet {
        height: 15px;
        width: 15px;
        background: none;
        border: 2px solid #989aa0;
        opacity: 1;

        &:not(:last-of-type) {
          margin-right: 10px;
        }

        &.swiper-pagination-bullet-active {
          background: #fff;
          border: 2px solid #fff;
        }
      }
    }
  }

  /* .cmp-learning-assignments.cmp-learning-assignments-with-slider {
    @media (max-width: 639px) {
      display: none;
    }
  } */

  .cmp-learning-assignments.cmp-learning-assignments-mobile {
    @media (min-width: 641px) {
      display: none;
    }
    .cmp-learning-card {
      max-width: 100%;
      height: 180px;

      &:not(:last-child) {
        margin-bottom: 15px;
      }
    }
  }

  .empty-state {
    padding: 24px 0;

    p {
      color: #fff;
      line-height: 21px;
    }

    @media (max-width: 768px) {
      padding: 20px;

      p {
        text-align: center;
        padding: 0 20px;
      }
    }
  }

  .loading-container {
    display: flex;

    .loading-card {
      height: 240px;
      width: 100%;
      background: #fff;
      border-radius: 7px;
      padding: 26px 24px 21px;
      display: flex;
      flex-direction: column;
      box-shadow: rgb(0 0 0 / 16%) 0px 3px 6px;

      &:not(:last-child) {
        margin-right: 20px;
      }

      .loading-card-footer {
        margin-top: auto;
        display: flex;
        justify-content: space-between;

        div {
          width: 35%;
        }
      }
    }
  }
`;

const Learning = () => {
  const [loading, setLoading] = useState(true);
  const [learningData, setLearningData] = useState(null);
  const [activeTab, setActiveTab] = useState("assignments");
  const [courses, setCourses] = useState(null);

  const { cmpData, environment, cuesURL, cmanURL, degreedURL } = useAuth();

  function handleGAEvent(eventTitle, value) {
    if (cmpData) {
      if (window.location.host == "mycues.cues.org") {
        ReactGA.event(eventTitle, {
          value,
          user_role: cmpData.account_info.acgiRole,
          user_memberlevel: cmpData.account_info.membershipLevel,
          user_company: cmpData.account_info.employer,
        });
      }
    }
  }

  useEffect(() => {
    if (environment == "local") {
      setLearningData({
        learning: {
          assigned: [
            {
              type: "content",
              id: "zQlX29j",
              attributes: {
                "content-type": "Article",
                "external-id": null,
                title: "Realizing The Potential Of Big Data",
                summary:
                  "More than 2.5 quintillion bytes are created every day through many different activities: social media posts, business transactions, cell phone GPS, supply chain and logistics data, business apps, digital video and audio, and pictures. Individuals generate 70 percent of all data; enterprises store and manage 80 percent of this data.",
                url: "https://www.fieldtechnologiesonline.com/doc/realizing-the-potential-of-big-data-0001",
                format: null,
                "is-obsolete": false,
                "image-url":
                  "https://vertassets.blob.core.windows.net/image/61ed64b7/61ed64b7-d632-4d48-adf2-7cd822cfe99e/375_250-big_dataaa.jpg",
                language: "en",
                duration: 1308,
                "duration-type": "Words",
                provider: null,
                "is-internal": true,
                owner: null,
                "created-at": "2022-04-30T20:36:53.120638",
                "modified-at": "2022-04-30T20:36:53.6831193",
                "degreed-url":
                  "https://betatest.degreed.com/articles/?d=MPLE67Y2D9",
              },
              links: {
                self: "https://api.betatest.degreed.com/api/v2/content/zQlX29j",
              },
              status: "pending",
              "due-at": "2022-06-15T00:00:00",
              "created-at": "2022-05-18T15:56:03.6228356",
              "modified-at": null,
              "assignment-type": "assigned",
              "employee-id": "1078492",
            },
            {
              type: "content",
              id: "zQlmmoa",
              attributes: {
                "content-type": "Article",
                "external-id": null,
                title: "Reducing Risk In Your Loan Portfolio",
                summary:
                  "When it comes to protecting your credit union’s collateral, tracking alone is not enough.",
                url: "https://www.cumanagement.com/articles/2022/05/reducing-risk-your-loan-portfolio",
                format: "Online",
                "is-obsolete": false,
                "image-url":
                  "https://www.cumanagement.com/sites/default/files/2022-04/Reduce-risk-loan-portfolio-State-National.jpg",
                language: "en",
                duration: 599,
                "duration-type": "Words",
                provider: null,
                "is-internal": true,
                owner: null,
                "created-at": "2022-05-02T18:02:36.382959",
                "modified-at": "2022-05-02T18:02:53.9455462",
                "degreed-url":
                  "https://betatest.degreed.com/articles/?d=1PNMDY22N9",
              },
              links: {
                self: "https://api.betatest.degreed.com/api/v2/content/zQlmmoa",
              },
              status: "pending",
              "due-at": "2022-06-10T00:00:00",
              "created-at": "2022-05-18T17:57:44.4633919",
              "modified-at": null,
              "assignment-type": "assigned",
              "employee-id": "1078492",
            },
            {
              type: "content",
              id: "zlRvWa",
              attributes: {
                "content-type": "Article",
                "external-id": "22481",
                title: "Purpose, Engagement and Communication",
                summary:
                  '<p><em>Sponsored by CUES Supplier member <strong><a href="https://www.passageways.com/onsemble-5min-demo2?utm_Source=Campaign&amp;utm_Comment=CUES">Passageways</a></strong>&nbsp;</em><br />\r\nIn the blink of an eye, it seems, we’ve witnessed immense technological change in how we communicate, collaborate and get things done at work. Effectively managing this change has become a key source of every organization\'s competitive advantage. What makes change management so difficult is often user resistance.&nbsp;<br />\r\n<br />\r\nToday’s younger workforce, encompassing Gen X, millennials and Gen Z, have new—sometimes conflicting—expectations about how technology must be integrated into the workplace. But make no mistake, focusing and deploying resources to implement a digital workspace that improves communication and collaboration can be a key driver of success.&nbsp;<br />\r\n<br />\r\nLet’s explore three ways digital workspace communication tools can bridge the generational and technological gap and ensure your whole team stays on the same page.&nbsp;<br />\r\n<br />\r\n<strong>1. Higher Productivity and Increased Purpose</strong><br />\r\nMillennials and Gen Z have grown up with social media, baring witness to a daily stream of likes, shares and comments. It has given them a platform to be valued and listened to, and has helped them gain a sense of belonging. By deploying a system that provides transparency to an organization’s shared goals, each individual can see their direct impact and value as a team member.&nbsp;</p>\r\n\r\n<p><strong><a href="https://www.simplicity.coop">Simplicity Credit Union</a></strong>, Marshfield, Wis., is an excellent example of how a robust communications platform can drive a sense of purpose and, as a result, increase productivity. The $250 million CU sought to get the word out about their new Signature Loans campaign without sending staff an endless volume of emails that would be ignored. They leveraged their intranet as an <strong><a href="',
                url: "https://www.cues.org/node/22481",
                format: "Online",
                "is-obsolete": false,
                "image-url":
                  "https://www.cues.org/sites/default/files/2018-08/8-28-18.jpg",
                language: null,
                duration: 742,
                "duration-type": "Words",
                provider: "ccube",
                "is-internal": true,
                owner: null,
                "created-at": "2018-08-27T19:16:43.3229006",
                "modified-at": "2018-08-27T19:16:43.3229006",
                "degreed-url":
                  "https://betatest.degreed.com/articles/?d=O973VWKG8N",
              },
              links: {
                self: "https://api.betatest.degreed.com/api/v2/content/zlRvWa",
              },
              status: "pending",
              "due-at": "2022-09-30T00:00:00",
              "created-at": "2022-05-23T12:33:47.1314051",
              "modified-at": null,
              "assignment-type": "assigned",
              "employee-id": "1078492",
            },
          ],
          completed: [
            {
              type: "content",
              id: "z65v2yW",
              attributes: {
                "content-type": "Article",
                "external-id": "24411",
                title:
                  "I’m A Trainer, How Do I Hype Up the Membership Benefits to Staff?",
                summary:
                  "<p>July 25, 2019<br />\r\n1:00 p.m. CST</p>\r\n\r\n<p><strong>Description: </strong>You are the trainer or responsible for the talent development at your credit union, and have just started your CUES membership. You want to get your staff and board excited about the opportunities CUES benefits bring to your organization.</p>\r\n\r\n<h3>Key Takeaways:</h3>\r\n\r\n<p>During this session, you’ll receive tips on ways to leverage CUES Membership benefits to:</p>\r\n\r\n<ul>\r\n\t<li>Get your staff excited for the educational opportunities at their fingertips</li>\r\n\t<li>Use the CUES Learning Portal points as incentives in creative ways</li>\r\n\t<li>Access reports to show usage particular to your credit union, and amp up friendly competition</li>\r\n\t<li>Connect with industry professionals to share training ideas and topics</li>\r\n</ul>\r\n\r\n<h3>Who Should Attend:&nbsp;</h3>\r\n\r\n<p>This session was created for credit union trainers with individual or group memberships. This is not for board members.&nbsp;</p>\r\n\r\n<h3>Topics of Discussion</h3>\r\n\r\n<ol>\r\n\t<li>Welcome and Introduction</li>\r\n\t<li>Introduce the Engagement Team</li>\r\n\t<li>Board, CEO/executive, and staff opportunities for Individuals and Groups</li>\r\n\t<li>What can I do with this membership as a trainer?\r\n\t<ol>\r\n\t\t<li>Learning and Development Opportunities\r\n\t\t<ol>\r\n\t\t\t<li>CUES Learning Portal with point systems</li>\r\n\t\t\t<li>The downloadable reporting features of CUES Learning Portal</li>\r\n\t\t\t<li>How to create your own pathway for your specific CU needs</li>\r\n\t\t\t<li>Elite Access courses and Webinars</li>\r\n\t\t\t<li>CUESNet demonstration—connecting with professional peers</li>\r\n\t\t</ol>\r\n\t\t</li>\r\n\t</ol>\r\n\t</li>\r\n</ol>",
                url: "https://www.cues.org/professional-development/training-education/webinars/trainer-hype-membership",
                format: null,
                "is-obsolete": false,
                "image-url": "",
                language: "en-US",
                duration: 179,
                "duration-type": "Words",
                provider: "cues",
                "is-internal": true,
                owner: null,
                "created-at": "2019-06-18T13:35:13.6011497",
                "modified-at": "2019-06-18T13:35:13.6011497",
                "degreed-url":
                  "https://betatest.degreed.com/articles/?d=V83GQYVQPX",
              },
              links: {
                self: "https://api.betatest.degreed.com/api/v2/content/z65v2yW",
              },
              status: "complete",
              "due-at": "2022-06-22T00:00:00",
              "created-at": "2022-05-18T15:55:27.8725852",
              "modified-at": "2022-05-18T15:55:27.7319514",
              "assignment-type": "assigned",
              "employee-id": "1078492",
            },
            {
              type: "content",
              id: "z65v2yW",
              attributes: {
                "content-type": "Article",
                "external-id": "24411",
                title:
                  "I’m A Trainer, How Do I Hype Up the Membership Benefits to Staff?",
                summary:
                  "<p>July 25, 2019<br />\r\n1:00 p.m. CST</p>\r\n\r\n<p><strong>Description: </strong>You are the trainer or responsible for the talent development at your credit union, and have just started your CUES membership. You want to get your staff and board excited about the opportunities CUES benefits bring to your organization.</p>\r\n\r\n<h3>Key Takeaways:</h3>\r\n\r\n<p>During this session, you’ll receive tips on ways to leverage CUES Membership benefits to:</p>\r\n\r\n<ul>\r\n\t<li>Get your staff excited for the educational opportunities at their fingertips</li>\r\n\t<li>Use the CUES Learning Portal points as incentives in creative ways</li>\r\n\t<li>Access reports to show usage particular to your credit union, and amp up friendly competition</li>\r\n\t<li>Connect with industry professionals to share training ideas and topics</li>\r\n</ul>\r\n\r\n<h3>Who Should Attend:&nbsp;</h3>\r\n\r\n<p>This session was created for credit union trainers with individual or group memberships. This is not for board members.&nbsp;</p>\r\n\r\n<h3>Topics of Discussion</h3>\r\n\r\n<ol>\r\n\t<li>Welcome and Introduction</li>\r\n\t<li>Introduce the Engagement Team</li>\r\n\t<li>Board, CEO/executive, and staff opportunities for Individuals and Groups</li>\r\n\t<li>What can I do with this membership as a trainer?\r\n\t<ol>\r\n\t\t<li>Learning and Development Opportunities\r\n\t\t<ol>\r\n\t\t\t<li>CUES Learning Portal with point systems</li>\r\n\t\t\t<li>The downloadable reporting features of CUES Learning Portal</li>\r\n\t\t\t<li>How to create your own pathway for your specific CU needs</li>\r\n\t\t\t<li>Elite Access courses and Webinars</li>\r\n\t\t\t<li>CUESNet demonstration—connecting with professional peers</li>\r\n\t\t</ol>\r\n\t\t</li>\r\n\t</ol>\r\n\t</li>\r\n</ol>",
                url: "https://www.cues.org/professional-development/training-education/webinars/trainer-hype-membership",
                format: null,
                "is-obsolete": false,
                "image-url": "",
                language: "en-US",
                duration: 179,
                "duration-type": "Words",
                provider: "cues",
                "is-internal": true,
                owner: null,
                "created-at": "2019-06-18T13:35:13.6011497",
                "modified-at": "2019-06-18T13:35:13.6011497",
                "degreed-url":
                  "https://betatest.degreed.com/articles/?d=V83GQYVQPX",
              },
              links: {
                self: "https://api.betatest.degreed.com/api/v2/content/z65v2yW",
              },
              status: "complete",
              "due-at": "2022-07-13T00:00:00",
              "created-at": "2022-05-18T17:58:22.3698818",
              "modified-at": "2022-05-18T17:58:22.3229803",
              "assignment-type": "assigned",
              "employee-id": "1078492",
            },
            {
              type: "content",
              id: "zlR84m",
              attributes: {
                "content-type": "Article",
                "external-id": "22511",
                title: "CEO Institute I: Strategic Planning",
                summary:
                  '<hr />\r\n<p>Contact <a href="mailto:teresab@cues.org">Teresa Brogan</a>, executive education specialist, to register.</p>\r\n\r\n<hr />\r\n<p>Learn to turn challenges into change at CEO Institute I. Delve into strategic planning through embracing uncertainty, rather than ignoring it. Discover how change can positively affect your organization while discussing:</p>\r\n\r\n<ul>\r\n\t<li>The driving forces that shape your business</li>\r\n\t<li>Maintaining a competitive advantage in changing times</li>\r\n\t<li>Viable change scenarios and potential outcomes</li>\r\n\t<li>How&nbsp; to formulate and focus your vision</li>\r\n\t<li>The strengths of effective leaders and how you can enhance your own leadership skills</li>\r\n</ul>\r\n\r\n<p>Following CEO Institute I, apply what you learned to your credit union in a hands-on, post segment assignment.&nbsp;<span>&nbsp;</span><span class="paragraph_overview_title" style="box-sizing: border-box;">&nbsp;</span></p>\r\n\r\n<p><strong style="box-sizing: border-box; font-family: ArialBold; font-weight: bold;">Register today!</strong></p>\r\n\r\n<p>U.S. News &amp; World Reportranked the<strong><a href="http://grad-schools.usnews.rankingsandreviews.com/best-graduate-schools/top-business-schools/university-of-pennsylvania-wharton-01194" target="_blank">Wharton School of the University of Pennsylvania</a></strong>#3 in its list of 2016 Best Business Schools</p>',
                url: "https://cuesupdate2018gvidjck9kv.devcloud.acquia-sites.com/node/22511",
                format: "Online",
                "is-obsolete": false,
                "image-url": "",
                language: "en-US",
                duration: 125,
                "duration-type": "Words",
                provider: "ccube",
                "is-internal": true,
                owner: null,
                "created-at": "2018-08-28T13:56:29.3328352",
                "modified-at": "2018-10-17T16:44:31.4404835",
                "degreed-url":
                  "https://betatest.degreed.com/articles/?d=3PM10E4Q9N",
              },
              links: {
                self: "https://api.betatest.degreed.com/api/v2/content/zlR84m",
              },
              status: "complete",
              "due-at": "2022-06-11T00:00:00",
              "created-at": "2022-05-18T17:59:29.1827735",
              "modified-at": "2022-05-18T17:59:29.1359032",
              "assignment-type": "assigned",
              "employee-id": "1078492",
            },
            {
              type: "content",
              id: "nkYaxNw",
              attributes: {
                "content-type": "Video",
                "external-id": null,
                title: "Succession Planning Is Critical and Multifaceted",
                summary:
                  "Succession planning has always been a good idea. But with so many possible retirements coming up in the world of credit unions and lots of other change in the world of financial services, it's worth an extra look these days.",
                url: "https://www.cumanagement.com/videos/2022/05/succession-planning-critical-and-multifaceted",
                format: null,
                "is-obsolete": false,
                "image-url":
                  "~/content/img/org/473/c6108fae-fbb7-4820-a379-b39044e4602c.jpg",
                language: "en",
                duration: 420,
                "duration-type": "Seconds",
                provider: null,
                "is-internal": true,
                owner: "Lynette",
                "created-at": "2022-05-02T18:05:48.5870795",
                "modified-at": "2022-05-02T18:06:21.508738",
                "degreed-url":
                  "https://betatest.degreed.com/videos/?d=79XJWYXXKP",
              },
              links: {
                self: "https://api.betatest.degreed.com/api/v2/content/nkYaxNw",
              },
              status: "complete",
              "due-at": "2022-06-10T00:00:00",
              "created-at": "2022-05-18T15:54:21.4188124",
              "modified-at": "2022-05-23T11:34:31.9221763",
              "assignment-type": "assigned",
              "employee-id": "1078492",
            },
            {
              type: "content",
              id: "nkYaxNw",
              attributes: {
                "content-type": "Video",
                "external-id": null,
                title: "Succession Planning Is Critical and Multifaceted",
                summary:
                  "Succession planning has always been a good idea. But with so many possible retirements coming up in the world of credit unions and lots of other change in the world of financial services, it's worth an extra look these days.",
                url: "https://www.cumanagement.com/videos/2022/05/succession-planning-critical-and-multifaceted",
                format: null,
                "is-obsolete": false,
                "image-url":
                  "~/content/img/org/473/c6108fae-fbb7-4820-a379-b39044e4602c.jpg",
                language: "en",
                duration: 420,
                "duration-type": "Seconds",
                provider: null,
                "is-internal": true,
                owner: "Lynette",
                "created-at": "2022-05-02T18:05:48.5870795",
                "modified-at": "2022-05-02T18:06:21.508738",
                "degreed-url":
                  "https://betatest.degreed.com/videos/?d=79XJWYXXKP",
              },
              links: {
                self: "https://api.betatest.degreed.com/api/v2/content/nkYaxNw",
              },
              status: "complete",
              "due-at": "2022-06-11T00:00:00",
              "created-at": "2022-05-18T17:57:26.6507382",
              "modified-at": "2022-05-23T11:34:31.9221763",
              "assignment-type": "assigned",
              "employee-id": "1078492",
            },
            {
              type: "content",
              id: "zln78j",
              attributes: {
                "content-type": "Article",
                "external-id": "22796",
                title: "Three Ways Digital 401(k) Improves Results",
                summary:
                  "<p>Advancing digital technology continues to transform the 401(k) experience for plan sponsors and participants. If your credit union, like many, still uses mostly paper-based procedures for 401(k) enrollment and distributions, consider these three key advantages of a digitally based program.</p>\r\n\r\n<p><strong>Digital Advantage #1: A personalized experience that helps employees easily and effectively manage their 401(k).</strong></p>\r\n\r\n<p>Engaging your participants in actively managing their 401(k) program starts with how easy it is to access their account information. They should be able to log-on to their account with their device of choice—desktop, tablet or smartphone—and easily do what they need to do.</p>\r\n\r\n<p>Most credit unions already provide online banking services that members can use easily on any device, right? So, give your 401(k) participants the same type of experience. They should be able to view their account information, change investment funds and contribution percentages, etc., easily from any device, anywhere.</p>\r\n\r\n<p>If your 401(k) provider offers a mobile app, consider offering and promoting it to your participants. Mobile devices are increasingly being used by consumers to learn, make transactions and manage their finances. Meet your plan participants where most of them are: on their smartphones and tablets.</p>\r\n\r\n<p>Digital technology today can do much more than simply provide users with easier access to 401(k) account information and transactions: It can personalize the experience for each user.</p>\r\n\r\n<p>A digital platform can track each participant’s transactions, savings progress, age, income, etc., and curate a selection of articles, budgeting tools, and other materials based specifically on these factors. The more employees interact with the system, the more relevant information is shared with the participant in an effort to anticipate their needs.</p>\r\n\r\n<p><strong>Digital Advantage #2: Stronger security that guards against",
                url: "https://www.cues.org/node/22796",
                format: "Online",
                "is-obsolete": false,
                "image-url":
                  "https://www.cues.org/sites/default/files/2018-09/9-14-18_cmg.jpg",
                language: null,
                duration: 912,
                "duration-type": "Words",
                provider: "ccube",
                "is-internal": true,
                owner: null,
                "created-at": "2018-09-14T15:03:39.0861029",
                "modified-at": "2018-09-14T15:03:39.0861029",
                "degreed-url":
                  "https://betatest.degreed.com/articles/?d=49E50JOW85",
              },
              links: {
                self: "https://api.betatest.degreed.com/api/v2/content/zln78j",
              },
              status: "complete",
              "due-at": "2022-06-30T00:00:00",
              "created-at": "2022-05-23T12:31:11.6305671",
              "modified-at": "2022-05-23T12:35:40.6635104",
              "assignment-type": "assigned",
              "employee-id": "1078492",
            },
            {
              type: "content",
              id: "rrg3k93",
              attributes: {
                "content-type": "Course",
                "external-id": "BH121212",
                title: "Branden Test - Developing Intelligent Bots",
                summary:
                  "Throughout this course, you will learn how to Design, Develop, Test/Debug and Deploy/Publish intelligent bots using Bot Builder SDK (.NET), Azure Bot Service and Azure Cognitive Services.",
                url: "https://mva.microsoft.com/en-US/training-courses/developing-intelligent-bots-from-zero-to-hero-17797?l=MzJTnlC6D_2605192810#",
                format: null,
                "is-obsolete": false,
                "image-url": null,
                language: null,
                duration: 16,
                "duration-type": "Hours",
                provider: null,
                "is-internal": true,
                owner: null,
                "created-at": "2018-07-27T18:18:16.0778147",
                "modified-at": "2018-07-27T18:18:16",
                "degreed-url":
                  "https://betatest.degreed.com/courses/?d=08Q10ZKE9R",
              },
              links: {
                self: "https://api.betatest.degreed.com/api/v2/content/rrg3k93",
              },
              status: "complete",
              "due-at": "2022-09-22T00:00:00",
              "created-at": "2022-05-23T12:32:53.0530489",
              "modified-at": "2022-05-23T12:52:49.0290611",
              "assignment-type": "assigned",
              "employee-id": "1078492",
            },
          ],
        },
      });

      setLoading(false);
    } else {
      axios
        .get(cuesURL + "/cmp/degreed")
        .then(function (response) {
          setLearningData(response.data);
          setLoading(false);
        })
        .catch(function (error) {
          setLoading(false);
        });
    }
  }, [loading]);

  useEffect(() => {
    if (!loading) {
      switch (activeTab) {
        case "assignments":
          setCourses(learningData.learning.assigned);
          break;
        case "completed":
          setCourses(learningData.learning.completed);
          break;
        default:
          console.log("I don't know what courses to show...");
      }
    }
  }, [loading, activeTab]);

  return (
    <>
      {loading && (
        <LearningElement>
          <div className="cmp-learning-container">
            {/* Header */}
            <div className="cmp-learning-header">
              <div className="cmp-learning-header-content">
                <h2>Learning</h2>
              </div>
            </div>

            <div className="loading-container">
              <div className="loading-card">
                <div className="loading-card-header">
                  <Skeleton count={3} height={24} />
                </div>

                <div className="loading-card-footer">
                  <div>
                    <Skeleton count={1} height={24} />
                  </div>
                  <div>
                    <Skeleton count={1} height={24} />
                  </div>
                </div>
              </div>

              <div className="loading-card">
                <div className="loading-card-header">
                  <Skeleton count={3} height={24} />
                </div>

                <div className="loading-card-footer">
                  <div>
                    <Skeleton count={1} height={24} />
                  </div>
                  <div>
                    <Skeleton count={1} height={24} />
                  </div>
                </div>
              </div>

              <div className="loading-card">
                <div className="loading-card-header">
                  <Skeleton count={3} height={24} />
                </div>

                <div className="loading-card-footer">
                  <div>
                    <Skeleton count={1} height={24} />
                  </div>
                  <div>
                    <Skeleton count={1} height={24} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </LearningElement>
      )}

      {!loading && learningData && (
        <LearningElement>
          <div className="cmp-learning-container">
            {/* Header */}
            <div className="cmp-learning-header">
              <div className="cmp-learning-header-content">
                <h2>My CUES Learning</h2>
              </div>

              <ul className="cmp-learning-tabs">
                <li>
                  <button
                    className={activeTab == "assignments" ? "active" : ""}
                    onClick={() => {
                      setActiveTab("assignments");
                    }}
                  >
                    Assignments
                  </button>
                </li>
                <li>
                  <button
                    className={activeTab == "completed" ? "active" : ""}
                    onClick={() => {
                      setActiveTab("completed");
                    }}
                  >
                    Completed
                  </button>
                </li>
              </ul>

              <a
                href={cuesURL + "/degreed/learning_tracker"}
                target="_blank"
                className=""
                onClick={() => {
                  handleGAEvent("learning_visitportal");
                }}
              >
                Visit CUES Learning Portal
              </a>
            </div>

            {activeTab == "assignments" && (
              <>
                {/* All Assignments Section */}
                {/* Mobile - No Slider */}
                {/* <div className="cmp-learning-assignments cmp-learning-assignments-mobile">
                  {courses ? (
                    <>
                      {Object.values(courses).map((course) => (
                        <div className="cmp-learning-card">
                          <div className="cmp-learning-card-header">
                            {course.attributes && course.attributes.title && (
                              <p className="cmp-learning-card-title">
                                {course.attributes.title}
                              </p>
                            )}

                            {course.attributes &&
                              course.attributes["degreed-url"] && (
                                <a
                                  href={course.attributes["degreed-url"]}
                                  target="_blank"
                                  className="cmp-learning-card-link"
                                >
                                  View
                                </a>
                              )}
                          </div>

                          <div className="cmp-learning-card-footer">
                            {course["due-at"] && (
                              <p className="cmp-learning-card-due-date">
                                {`Due: ${new Date(
                                  course["due-at"]
                                ).toLocaleDateString()}`}
                              </p>
                            )}

                            {course.attributes &&
                              course.attributes["content-type"] && (
                                <p className="cmp-learning-card-course-length">
                                  {course.attributes["content-type"]}
                                </p>
                              )}
                          </div>
                        </div>
                      ))}
                    </>
                  ) : (
                    <div className="empty-state">
                      <p>
                        Watch for your assignments to appear here as they come
                        in! While you're waiting, you can get started on your
                        own by visiting CUES Learning Portal and completing your
                        profile, which will give you a more personalized
                        learning experience.
                      </p>
                    </div>
                  )}
                </div> */}

                {/* Desktop/Tablet - Slider */}
                <div className="cmp-learning-assignments cmp-learning-assignments-with-slider">
                  {courses ? (
                    <Swiper
                      slidesPerView={1}
                      grid={{
                        rows: 2,
                      }}
                      spaceBetween={30}
                      pagination={{
                        clickable: true,
                      }}
                      modules={[Grid, Pagination]}
                      className="mySwiper"
                      breakpoints={{
                        480: {
                          slidesPerView: 2,
                          slidesPerGroup: 4,
                          grid: {
                            rows: 2,
                          },
                        },
                        769: {
                          slidesPerView: 3,
                          slidesPerGroup: 6,
                          grid: {
                            rows: 2,
                          },
                        },
                      }}
                    >
                      <>
                        {Object.values(courses).map((course) => (
                          <SwiperSlide>
                            <div className="cmp-learning-card">
                              <div className="cmp-learning-card-header">
                                {course.attributes &&
                                  course.attributes.title && (
                                    <p className="cmp-learning-card-title">
                                      {course.attributes.title}
                                    </p>
                                  )}

                                {course.attributes &&
                                  course.attributes["degreed-url"] && (
                                    <a
                                      href={course.attributes["degreed-url"]}
                                      target="_blank"
                                      className="cmp-learning-card-link"
                                      onClick={() => {
                                        handleGAEvent(
                                          "learning_assigned",
                                          course.attributes.title
                                        );
                                      }}
                                    >
                                      View
                                    </a>
                                  )}
                              </div>

                              <div className="cmp-learning-card-footer">
                                {course["due-at"] && (
                                  <p className="cmp-learning-card-due-date">
                                    {`Due: ${new Date(
                                      course["due-at"]
                                    ).toLocaleDateString()}`}
                                  </p>
                                )}

                                {course.attributes &&
                                  course.attributes["content-type"] && (
                                    <p className="cmp-learning-card-course-length">
                                      {course.attributes["content-type"]}
                                    </p>
                                  )}
                              </div>
                            </div>
                          </SwiperSlide>
                        ))}
                      </>
                    </Swiper>
                  ) : (
                    <div className="empty-state">
                      <p>
                        Watch for your assignments to appear here as they come
                        in! While you're waiting, you can get started on your
                        own by visiting CUES Learning Portal and completing your
                        profile, which will give you a more personalized
                        learning experience.
                      </p>
                    </div>
                  )}
                </div>
              </>
            )}

            {activeTab == "completed" && (
              <>
                {/* Completed Assignments Section */}
                {/* Mobile - No Slider */}
                {/* <div className="cmp-learning-assignments cmp-learning-assignments-mobile">
                  {courses ? (
                    <>
                      {Object.values(courses).map((course) => (
                        <div className="cmp-learning-card">
                          <div className="cmp-learning-card-header">
                            {course.attributes && course.attributes.title && (
                              <p className="cmp-learning-card-title">
                                {course.attributes.title}
                              </p>
                            )}

                            {course.attributes &&
                              course.attributes["degreed-url"] && (
                                <a
                                  href={course.attributes["degreed-url"]}
                                  target="_blank"
                                  className="cmp-learning-card-link"
                                >
                                  View
                                </a>
                              )}
                          </div>

                          <div className="cmp-learning-card-footer">
                            {course.attributes &&
                              course.attributes["content-type"] && (
                                <p className="cmp-learning-card-course-length">
                                  {course.attributes["content-type"]}
                                </p>
                              )}
                          </div>
                        </div>
                      ))}
                    </>
                  ) : (
                    <div className="empty-state">
                      <p>
                        Looks like you haven't completed any courses yet—but
                        that's ok, it's easy to get started! Simply visit CUES
                        Learning Portal to complete your profile and add your
                        skills, which will give you a more personalized learning
                        experience.
                      </p>
                    </div>
                  )}
                </div> */}

                {/* Desktop/Tablet - Slider */}
                <div className="cmp-learning-assignments cmp-learning-assignments-with-slider">
                  {courses ? (
                    <Swiper
                      slidesPerView={1}
                      grid={{
                        rows: 2,
                      }}
                      spaceBetween={30}
                      pagination={{
                        clickable: true,
                      }}
                      modules={[Grid, Pagination]}
                      className="mySwiper"
                      breakpoints={{
                        480: {
                          slidesPerView: 2,
                          slidesPerGroup: 4,
                          grid: {
                            rows: 2,
                          },
                        },
                        769: {
                          slidesPerView: 3,
                          slidesPerGroup: 6,
                          grid: {
                            rows: 2,
                          },
                        },
                      }}
                    >
                      <>
                        {Object.values(courses).map((course) => (
                          <SwiperSlide>
                            <div className="cmp-learning-card">
                              <div className="cmp-learning-card-header">
                                {course.attributes &&
                                  course.attributes.title && (
                                    <p className="cmp-learning-card-title">
                                      {course.attributes.title}
                                    </p>
                                  )}

                                {course.attributes &&
                                  course.attributes["degreed-url"] && (
                                    <a
                                      href={course.attributes["degreed-url"]}
                                      target="_blank"
                                      className="cmp-learning-card-link"
                                      onClick={() => {
                                        handleGAEvent(
                                          "learning_completed",
                                          course.attributes.title
                                        );
                                      }}
                                    >
                                      View
                                    </a>
                                  )}
                              </div>

                              <div className="cmp-learning-card-footer">
                                {course.attributes &&
                                  course.attributes["content-type"] && (
                                    <p className="cmp-learning-card-course-length">
                                      {course.attributes["content-type"]}
                                    </p>
                                  )}
                              </div>
                            </div>
                          </SwiperSlide>
                        ))}
                      </>
                    </Swiper>
                  ) : (
                    <div className="empty-state">
                      <p>
                        Looks like you haven't completed any courses yet—but
                        that's ok, it's easy to get started! Simply visit CUES
                        Learning Portal to complete your profile and add your
                        skills, which will give you a more personalized learning
                        experience.
                      </p>
                    </div>
                  )}
                </div>
              </>
            )}
          </div>
        </LearningElement>
      )}
    </>
  );
};

export default Learning;
